import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import * as NotificationsActions from './notifications.actions';
import { cloneDeep } from 'lodash';
import { NotificationM } from '../models';

export const NOTIFICATIONS_FEATURE_KEY = 'notifications';

export interface State {
    loading: boolean;
    notifications: NotificationM[];
    per_page: number | null;
    previous_cursor: string | null;
    next_cursor: string | null;
}

export const initialState: State = {
    notifications: [],
    loading: false,
    per_page: null,
    previous_cursor: null,
    next_cursor: null
};

export const notificationsFeature = createFeature({
    name: NOTIFICATIONS_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(NotificationsActions.loadNotifications, state => ({
            ...state,
            loading: true
        })),
        on(NotificationsActions.loadNotificationsSuccess, (state, { data, loading_more }) => {
            const { data: notifications, ...rest } = data;
            return {
                ...state,
                loading: false,
                notifications: loading_more ? [...state.notifications, ...notifications] : notifications,
                ...rest
            };
        }),
        on(NotificationsActions.loadNotificationsFailure, (state, { error }) => ({
            ...state,
            isLoading: false
        })),
        on(NotificationsActions.markNotificationAsRead, (state, { id }) => {
            const index = state.notifications.findIndex(notification => notification.id === id);
            if (index !== -1) {
                const notifications = cloneDeep(state.notifications);
                notifications[index].read_at = new Date().toISOString();
                return {
                    ...state,
                    notifications
                };
            }
            return state;
        }),
        on(NotificationsActions.markNotificationAsReadFailure, (state, { id }) => {
            const index = state.notifications.findIndex(notification => notification.id === id);
            if (index !== -1) {
                const notifications = [...state.notifications];
                notifications[index].read_at = null;
                return {
                    ...state,
                    notifications
                };
            }
            return state;
        })
    )
});

export const {
    name,
    reducer,
    selectNotificationsState,
    selectNotifications,
    selectLoading: selectLoadingNotifications,
    selectNext_cursor: selectNextCursor,
    selectPrevious_cursor: selectPreviousCursor
} = notificationsFeature;

export const selectNotReadNotifications = createSelector(
    selectNotifications,
    notifications => notifications?.filter(notification => !notification.read_at) || []
);

export const selectNotReadNotificationsCount = createSelector(
    selectNotReadNotifications,
    notifications => notifications.length
);
